'use es6';

import { DropTarget } from 'react-dnd-compat';
import DragTypes from 'simple-menus-core/enums/DragTypes';
const target = {
  canDrop(props) {
    return !props.isParentDragging;
  },
  drop(props, monitor) {
    if (monitor.didDrop()) return;
    props.moveNode(monitor.getItem());
  }
};
export default function menuDividerDropTarget() {
  return Component => {
    return DropTarget(DragTypes.ADVANCED_MENUS_MENU_NODE, target, monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }))(Component);
  };
}